import React from 'react';

/* ── Workout Timer ───────────────────────────────────────────── */
// Self-contained 1Hz ticker for the active-workout sticky header.
// Lives in its own component so its 1-second re-renders don't bubble up to the
// parent (which would re-evaluate hundreds of set rows every tick). Reads
// elapsed seconds directly from `startedAt` so it stays correct even after a
// tab regains focus from being throttled in the background.
export default function WorkoutTimer({ startedAt, isRunning }) {
  const [now, setNow] = React.useState(Date.now());
  React.useEffect(() => {
    if (!isRunning || !startedAt) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [isRunning, startedAt]);
  const seconds = startedAt ? Math.max(0, Math.floor((now - startedAt) / 1000)) : 0;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return <>{`${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`}</>;
}
